import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSideNav from './adminsidenav';
import AdminNav from './adminnav';

const AdminLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const styles = {
    layoutContainer: {
      display: 'flex',
      minHeight: '100vh',
      background: '#f5f7fa',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    mainContent: {
      flex: 1,
      marginLeft: sidebarCollapsed ? '80px' : '260px',
      transition: 'margin-left 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    contentArea: {
      flex: 1,
      padding: '2rem',
      overflowY: 'auto',
    },
  };

  return (
    <div style={styles.layoutContainer}>
      {/* Side Navigation */}
      <AdminSideNav onToggle={setSidebarCollapsed} />

      {/* Main Content Area */}
      <div style={styles.mainContent}>
        {/* Top Navigation */}
        <AdminNav />

        {/* Page Content */}
        <main style={styles.contentArea}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;